export default __webpack_public_path__ + "static/style3.4_Regina-e175d66a9782206f11f48dcbe22cb83d.wav";